import apiClient from "@/api/apiClient";

export const getTickets = async () => {
  const result = await apiClient.get("/api/tickets");
  return result.data.tickets;
};

export const getTicket = async (ticketId) => {
  const result = await apiClient.get(`/api/tickets/${ticketId}`);
  return result.data;
};

export const createTicket = async (ticket) => {
  const result = await apiClient.post("/api/tickets", ticket);
  return result.data;
};

export const updateTicketStatus = async (ticketId, status) => {
  const result = await apiClient.patch(`/api/tickets/${ticketId}`, { status });
  return result.data;
};

export const addTicketComment = async (ticketId, text) => {
  const result = await apiClient.post(`/api/tickets/${ticketId}`, { text });
  return result.data;
};
